import { render, staticRenderFns } from "./AddThreadModal.vue?vue&type=template&id=3044cf09"
import script from "./AddThreadModal.vue?vue&type=script&lang=js"
export * from "./AddThreadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports